import { Button, Flex, FlexProps } from "@chakra-ui/react";
import { Dispatch, SetStateAction } from "react";
import { IoIosArrowRoundForward, IoIosArrowRoundBack } from "react-icons/io";


interface PaginationBarProps extends FlexProps {
  currentPageIndex: number;
  totalPageCount: number;
  setPage: Dispatch<SetStateAction<number>>;
}

export const PaginationBar = ({
  currentPageIndex,
  totalPageCount,
  setPage,
  ...rest
}: PaginationBarProps) => {
  const displayPageNumber = currentPageIndex + 1;
  return (
    <Flex
    justifyContent="space-between"
    alignItems="center"
      {...rest}>
      <Button
        variant={"rectanglePagination"}
        // aria-label={"Back"}
        leftIcon={<IoIosArrowRoundBack style={{ fontSize: "22px" }} />  }
        onClick={() => setPage(currentPageIndex - 1)}
        disabled={currentPageIndex === 0}
      >
        Previous
      </Button>
      <Flex
        justifyContent="center"
        alignItems="center"
        gap="5px" 
      >
      <Button
        variant={"pagination"}
        hidden={currentPageIndex <= 1}
        gap="2px"
        onClick={() => setPage(0)}
      >
        1
      </Button>
      <Button
        variant={"pagination"}
        hidden={currentPageIndex <= 2}
        onClick={() => setPage(currentPageIndex - 2)}
      >
        ...
      </Button>
      <Button
        variant={"numberPagination"}
        gap="2px"
        hidden={currentPageIndex === 0}
        onClick={() => setPage(currentPageIndex - 1)}
      >
        {displayPageNumber - 1}
      </Button>
      <Button
        variant={"numberPagination"}
        color={"primary.darker"}
        backgroundColor={"paginationSelect"}
        onClick={() => setPage(currentPageIndex)}
      >
        {displayPageNumber}
      </Button>
      <Button
        variant={"numberPagination"}
        hidden={currentPageIndex === totalPageCount - 1}
        onClick={() => setPage(currentPageIndex + 1)}
      >
        {displayPageNumber + 1}
      </Button>
      <Button
        variant={"numberPagination"}
        hidden={currentPageIndex >= totalPageCount - 3}
        onClick={() => setPage(currentPageIndex + 2)}
      >
        ...
      </Button>
      <Button
        variant={"numberPagination"}
        hidden={currentPageIndex >= totalPageCount - 2}
        onClick={() => setPage(totalPageCount - 1)}
      >
        {totalPageCount}
      </Button>
      </Flex>
      <Button
        variant={"rectanglePagination"}
        // aria-label={"Next"}
        rightIcon={<IoIosArrowRoundForward style={{ fontSize: "22px" }} />}
        onClick={() => setPage(currentPageIndex + 1)}
        disabled={currentPageIndex === totalPageCount - 1}
      >
        Next
        </Button>
    </Flex>
  );
};
